<template>
  <div class="tab-module">
    <div>
      <!-- 底部tab -->
      <!-- <mt-tabbar v-model="selected" fixed> -->
      <mt-tabbar fixed>
        <mt-tab-item id="首页" @click.native="goTabType(1)">
          <img
            v-if="selected == '首页'"
            slot="icon"
            src="../../assets/img/tab/index-selected.svg"
          />
          <img v-else slot="icon" src="../../assets/img/tab/index.svg" />
          <span
            class="tabbarFixedTitle"
            :class="{ 'selected-text': selected == '首页' }"
            >首页</span
          >
        </mt-tab-item>
        <mt-tab-item id="我的" @click.native="goTabType(2)">
          <img
            v-if="selected == '我的'"
            slot="icon"
            src="../../assets/img/tab/person-selected.svg"
          />
          <img v-else slot="icon" src="../../assets/img/tab/person.svg" />
          <span
            class="tabbarFixedTitle"
            :class="{ 'selected-text': selected == '我的' }"
            >我的</span
          >
        </mt-tab-item>
      </mt-tabbar>
      <van-badge v-if="messageNum>0" :content="messageNum" style="position: absolute;
        left: 65%;
        bottom: 1.8rem;
        z-index: 9999;
        font-size: 0.7rem;
        min-width: 1rem;
        padding: .1rem;"/>
    </div>
  </div>
</template>

  <script>
export default {
  components: {},
  beforeMount() {},
  props: {
    selected: {
      type: String,
      default: "首页",
    },
    messageNum: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    goTabType(index) {
      if (index == 1) {
        this.$router.push("/home");
      } else if (index == 2) {
        this.$router.push("/user");
      }
    },
  },
};
</script>

  <style>
.full-img {
  width: 100%;
  height: 100%;
}
.tab-module {
  width: 100%;
  background-color: #f1f5f8;
  font-family: "PingFangSC-Regular";
  color: black;
}
body {
  display: block;
  margin: 0rem !important;
}
.cell-block {
  margin-top: 0.6rem;
  width: 100%;
  height: auto;
}
.tab-module :deep(.page-wrap) {
  margin-bottom: 3rem;
}
.tab-module :deep(.mint-tabbar.is-fixed) {
  height: 6rem;
}

.tab-module .selected-text {
  color: #407bee;
}
.tab-module .tabbarFixedTitle {
  font-size:0.8rem !important;
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
</style>
